import React from 'react';
import classNames from 'classnames';
import { Shadows_Into_Light } from 'next/font/google';
import { useTranslations } from 'next-intl';

interface IProps {
  testType?: string;
  testsCount?: number;
}

const shadows = Shadows_Into_Light({
  subsets: ['latin'],
  weight: ['400']
});

const TestsCountCard: React.FC<IProps> = ({ testType, testsCount }) => {
  const t = useTranslations();

  return (
    <div className="h-28.5 flex flex-col justify-between rounded-xl bg-gray-50 px-3 pb-1.5 pt-3">
      <div>
        <div className="font-semibold text-gray-800">{testType}</div>
        <div className="text-xs font-medium text-gray-400">{t('testlar_soni')}</div>
      </div>
      <div className={classNames(shadows.className, 'text-end text-3xl')}>
        {testsCount?.toLocaleString('ru')} {t('ta')}
      </div>
    </div>
  );
};

export default TestsCountCard;
